import { Button, Modal, Form, Radio } from 'antd';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import DataBreachService from '../../../../../services/DataBreach.service';
import useNotify from '../../../../../context/Notification/useNotify';

const ModalSelfAssessment = ({
    open,
    title,
    loading,
    width = 135,
    setOpenSelfForm,
    id,
    selfAssessment,
    setEditFlag,
    form,
    question,
    questionSequence,
    setQuestionSequence,
    setSelfData,
    selfData,
    change,
    setChange
}) => {
    const { t, i18n } = useTranslation('data-breach');
    const lang = i18n?.language;
    const notify = useNotify();
    const [editAns, setEditAns] = useState(false);

    const checkSelfData = (qNo, value, detail, isRemove) => {
        const newData = {
            answer: String(value),
            detail: detail,
            sequence: qNo,
        };

        setSelfData((prevSelfData) => {
            let newSelfData;

            const index = prevSelfData.findIndex((item) => item.sequence === qNo);

            if (index !== -1) {
                newSelfData = [...prevSelfData];
                newSelfData[index] = newData;
            } else {
                newSelfData = [...prevSelfData, newData];
            }

            if (isRemove) {
                newSelfData = newSelfData.filter((item) => item.sequence <= qNo);
            }

            return newSelfData;
        });
    };

    const onFinish = (values) => {
        const currentkey = `q${questionSequence}`
        let isRemove = false
        switch (currentkey) {
            case 'q0':
                if (values.q0 === 2) {
                    setQuestionSequence(5)
                    isRemove = true
                } else if (values.q0 === 3) {
                    setQuestionSequence(6)
                    isRemove = true
                }
                checkSelfData(1, values.q0, question[questionSequence].q_en, isRemove)
                return;
            case 'q1':
                if (values.q1 === 2) {
                    setQuestionSequence(7)
                    isRemove = true
                }
                checkSelfData(2, values.q1, question[questionSequence].q_en, isRemove)
                return;
            case 'q2':
                if (values.q2 === 1) {
                    setQuestionSequence(8)
                    isRemove = true
                }
                checkSelfData(3, values.q2, question[questionSequence].q_en, isRemove)
                return;
            case 'q3':
                if (values.q3 === 2) {
                    setQuestionSequence(9)
                    isRemove = true
                } else if (values.q3 === 3) {
                    setQuestionSequence(10)
                    isRemove = true
                }
                checkSelfData(4, values.q3, question[questionSequence].q_en, isRemove)
                return;
            case 'q4':
                if (values.q4 === 1) {
                    setQuestionSequence(11)
                    isRemove = true
                } else if (values.q4 === 2) {
                    setQuestionSequence(12)
                    isRemove = true
                }
                checkSelfData(5, values.q4, question[questionSequence].q_en, isRemove)
                return;
            default:
                const payload = {
                    txnDataBreachId: id,
                    selfAssessmentList: selfData
                };
                if (selfAssessment.length > 0) {
                    DataBreachService.updateSelfAssessment(payload)
                        .then((res) => {
                            if (res.data.resultMsg === 'SUCCESS') {
                                setOpenSelfForm(false);
                            } else {
                                setOpenSelfForm(false);
                            }
                        })
                        .catch((err) => {
                            notify({
                                type: 'error',
                                title: t('Fail'),
                                description: t('FailedtoSubmitData'),
                                closeable: true,
                                timeOut: 120000,
                            });
                        });
                } else {
                    DataBreachService.createSelfAssessment(payload)
                        .then((res) => {
                            if (res.data.resultMsg === 'SUCCESS') {
                                setOpenSelfForm(false);
                            } else {
                                setOpenSelfForm(false);
                            }
                        })
                        .catch((err) => {
                            notify({
                                type: 'error',
                                title: t('Fail'),
                                description: t('FailedtoSubmitData'),
                                closeable: true,
                                timeOut: 120000,
                            });
                        });
                }
        }

    };

    useEffect(() => {
        if ((selfData.length !== questionSequence && !editAns)) {
            questionSequence < 5 && setQuestionSequence(questionSequence + 1);
        }
    }, [selfData]);

    const closeModal = () => {
        if (change) {
            setEditFlag(true);
        } else {
            setOpenSelfForm(false);
        }
    };

    const startAgain = () => {
        form.resetFields();
        setQuestionSequence(0);
        setSelfData([]);
    }

    const edit = async (sequence) => {
        const indexToRemove = sequence - 1;
        await setEditAns(true);
        const oldObj = selfData;
        const newObj = selfData.filter(item =>  item.sequence < sequence );

        if (newObj.length === 0) {
            await setQuestionSequence(0);
        } else {
            await setQuestionSequence(indexToRemove);
            form.setFieldsValue({
                [`q${indexToRemove}`]: Number(oldObj[indexToRemove].answer),
            });
        }
        await setSelfData(newObj);
        await setEditAns(false);
    };

    return (
        <Modal
            width={810}
            className="_modal-custom px-0"
            footer={false}
            open={open}
            onCancel={() => closeModal()}
            title={title}

        >
            <a
                onClick={() => startAgain()}
                className='px-6 border-0 hover:text-[#1890FF] focus:text-[#1890FF] text-[#1890FF] flex items-center hover:border-0 focus:border-0 active:border-0'>
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.7667 4.73366C10.8 3.76699 9.47334 3.16699 8.00001 3.16699C5.05334 3.16699 2.67334 5.55366 2.67334 8.50033C2.67334 11.447 5.05334 13.8337 8.00001 13.8337C10.4867 13.8337 12.56 12.1337 13.1533 9.83366H11.7667C11.22 11.387 9.74001 12.5003 8.00001 12.5003C5.79334 12.5003 4.00001 10.707 4.00001 8.50033C4.00001 6.29366 5.79334 4.50033 8.00001 4.50033C9.10667 4.50033 10.0933 4.96033 10.8133 5.68699L8.66667 7.83366H13.3333V3.16699L11.7667 4.73366Z" fill="#1890FF" />
                </svg>
                <span className='pl-2 underline'>
                    {t('Start again')}
                </span>
            </a>
            {
                selfData.length > 0 &&
                selfData.map((is, index) => {
                    return (
                        <div key={is.sequence} className='bg-[#F3F9FF] rounded-md mx-6 px-4 py-2 mt-2 flex items-center justify-between'>
                            <div>
                                <p className='mb-0 font-sm font-normal text-[#171717]'>{lang === "en" ? question[index].q_en : question[index].q_th}</p>
                                <p className='mb-0 font-sm font-semibold text-[#171717]'>{lang === "en" ? question[index].options[is.answer - 1].name_en : question[index].options[is.answer - 1].name_th}</p>
                            </div>
                            <a
                                onClick={() => edit(is.sequence)}
                                className='px-6 border-0 hover:text-[#1890FF] focus:text-[#1890FF] text-[#1890FF] flex items-center hover:border-0 focus:border-0 active:border-0'>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.6588 1.8418L14.6588 3.8418L13.1342 5.36713L11.1342 3.36713L12.6588 1.8418ZM5.3335 11.1671H7.3335L12.1915 6.30913L10.1915 4.30913L5.3335 9.16713V11.1671Z" fill="#1890FF" />
                                    <path d="M12.6667 13.1667H5.43867C5.42133 13.1667 5.40333 13.1733 5.386 13.1733C5.364 13.1733 5.342 13.1673 5.31933 13.1667H3.33333V3.83333H7.898L9.23133 2.5H3.33333C2.598 2.5 2 3.09733 2 3.83333V13.1667C2 13.9027 2.598 14.5 3.33333 14.5H12.6667C13.0203 14.5 13.3594 14.3595 13.6095 14.1095C13.8595 13.8594 14 13.5203 14 13.1667V7.388L12.6667 8.72133V13.1667Z" fill="#1890FF" />
                                </svg>
                                <span className='pl-2 underline'>
                                    {t('Edit answer')}
                                </span>
                            </a>
                        </div>
                    );
                })

            }
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onFinish={onFinish}
                form={form}
                className="w-full"
                layout="vertical"
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
            >
                {questionSequence <= 4 ?
                    <div className="self-assessment">
                        <p className="mb-0 text-sm	font-semibold px-6">
                            {
                                lang === 'en'
                                    ? question[questionSequence].q_en
                                    : question[questionSequence].q_th
                            }
                            <span className="text-error pl-2">*</span>
                        </p>
                        <Form.Item
                            label={
                               false
                            }
                            className="px-6 mb-0"
                        >
                            {lang === 'en'
                                ? <div className='py-2'>{parse(question[questionSequence].text_en)}</div>
                                : <div className='py-2'>{parse(question[questionSequence].text_th)}</div>}

                            <Form.Item
                                name={question[questionSequence].name}
                                rules={[
                                    {
                                        required: true,
                                        message: t('requiredField'),
                                    },
                                ]}
                            >
                                <Radio.Group className="w-full">
                                    {question[questionSequence].options.map((is) => (
                                        <div key={is.key}>
                                            <Radio value={is.key} style={{ lineHeight: '32px' }}>
                                                {lang === 'en' ? is.name_en : is.name_th}
                                            </Radio>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </Form.Item>
                    </div>
                    :
                    <div className='px-6 py-4'>
                        <p className='mb-0 font-semibold text-base'>
                            {lang === "en" ? question[questionSequence].q_en : question[questionSequence].q_th}
                        </p>
                        {lang === "en" ? parse(question[questionSequence].text_en) : parse(question[questionSequence].text_th)}
                    </div>
                }
                <div className="flex justify-end items-center border-t border-x-0 border-b-0 border-[#f0f0f0] border-solid">
                    <div className='px-6 pt-6'>
                        <Button
                            style={{ width }}
                            loading={loading}
                            // onClick={handelOk}
                            size="large"
                            htmlType="submit"
                            type="primary"
                            className="w-36"
                        >
                            <span className='font-medium font-sm'>{questionSequence > 4 ? t('Finished') : t('Continue')}</span>
                        </Button>

                    </div>
                </div>
            </Form>
        </Modal>
    );
};
export default ModalSelfAssessment;
